'use strict';

/**
 * Module definition for the album/photobox module
 *
 * @category   Model
 * @module     collection.album
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Marionette = require('backbone-marionette');
var Controller = require('./controller');
var PhotoboxCollection = require('./collections/photobox');
var UnusedCollection = require('./collections/unused');

var AlbumModule = Marionette.Module.extend({
    startWithParent: true,

    initialize: function(moduleName, app) {
        this.listenTo(app.vent, 'logged-in', function(){
            app.loadData(this.albumsPhotoboxCollection);
            app.loadData(this.albumsUnusedCollection);
        }.bind(this));
    },

    onStart: function(options) {
        var app = this.app;

        this.albumsPhotoboxCollection = new PhotoboxCollection();
        this.albumsUnusedCollection = new UnusedCollection();

        var controller = this.controller = new Controller({
            app: app,
            module: this,
        });

        app.addInitializer(function(){
            app.router.processAppRoutes(controller, controller.routes);
        }.bind(this));
    },
});

module.exports = AlbumModule;